import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { withScriptjs, withGoogleMap, GoogleMap } from 'react-google-maps'
import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer'
import PageLoading from 'core/components/page-loading'
import { Alert } from 'core/components/ui'
import stylesMap from './stylesMap'
import MarkerWrapper from './MarkerWrapper'

const GoogleMapWrapper = props => {
  const {
    styles,
    aMarkers,
    bMarkerClusterer,
    height,
    hasError,
    isLoading,
    fullscreenControl,
    mapTypeControl,
    streetViewControl,
    intl
  } = props

  const getStyles = () => {
    const indexStyles = styles > stylesMap.length - 1 || styles < 0 ? 0 : styles

    return stylesMap[indexStyles]
  }

  let renderContent = ''

  if (hasError) {
    renderContent = (
      <div style={{ width: '80%' }}>
        <Alert
          message={intl.formatMessage({ id: 'maps-error' })}
          type="error"
          data-test="component-maps-googleMapWrapper-error"
        />
      </div>
    )
  } else if (isLoading) {
    renderContent = <PageLoading data-test="component-maps-googleMapWrapper-loader" />
  } else if (aMarkers) {
    const marker = aMarkers[0]
    const { lat, lng } = marker

    const renderMarker = aMarkers.map(item => (
      <MarkerWrapper
        key={item.lat}
        lat={item.lat}
        lng={item.lng}
        infoWindowContent={item.infoWindowContent}
        title={item.title}
        icon={item.icon}
      />
    ))

    const stylesMapToApply = getStyles()

    const MyMapComponent = withScriptjs(
      withGoogleMap(() => (
        <GoogleMap
          defaultZoom={14}
          defaultCenter={{ lat, lng }}
          options={{
            fullscreenControl,
            mapTypeControl,
            streetViewControl,
            styles: stylesMapToApply.styles
          }}
        >
          {bMarkerClusterer ? (
            <MarkerClusterer>{renderMarker}</MarkerClusterer>
          ) : (
            <div>{renderMarker}</div>
          )}
        </GoogleMap>
      ))
    )

    renderContent = (
      <MyMapComponent
        googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyC7QLXp7sVaI6WJsAMnrSx757gQzVdWFKM&v=3.exp"
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `${height}px` }} />}
        mapElement={<div style={{ height: `100%` }} />}
        data-test="component-maps-googleMapWrapper-googleMap"
      />
    )
  } else {
    renderContent = (
      <div style={{ width: '80%' }}>
        <Alert
          message={intl.formatMessage({ id: 'maps-error' })}
          type="warning"
          data-test="component-maps-googleMapWrapper-no-datas"
        />
      </div>
    )
  }

  return <div data-test="component-maps-googleMapWrapper">{renderContent}</div>
}

GoogleMapWrapper.defaultProps = {
  fullscreenControl: false,
  mapTypeControl: false,
  streetViewControl: false,
  styles: 0,
  aMarkers: null,
  bMarkerClusterer: true,
  height: 600,
  hasError: false
}

// Gestion propTypes
GoogleMapWrapper.propTypes = {
  intl: PropTypes.shape().isRequired,
  isLoading: PropTypes.bool.isRequired,
  fullscreenControl: PropTypes.bool,
  mapTypeControl: PropTypes.bool,
  streetViewControl: PropTypes.bool,
  styles: PropTypes.number,
  aMarkers: PropTypes.arrayOf(PropTypes.any),
  bMarkerClusterer: PropTypes.bool,
  height: PropTypes.number,
  hasError: PropTypes.bool
}

export default injectIntl(GoogleMapWrapper)
